import type { ButtonProps } from '@mui/material';
import { Button, styled } from '@mui/material';

export type TabContainerProps = {
  isActive: boolean;
} & ButtonProps;

export const TabContainer = styled(Button, { shouldForwardProp: (prop) => prop !== 'isActive' })<TabContainerProps>(({ theme, isActive }) => ({
  width: '300px',
  height: '72px',
  padding: '16px',
  borderRadius: '8px',
  overflow: 'hidden',
  backgroundColor: 'white',
  textAlign: 'left',
  alignItems: 'center',
  display: 'flex',
  position: 'relative',
  boxShadow: theme.shadows[1],
  color: isActive ? '#0D1B27DE' : theme.palette.text.secondary,
  '&:after': isActive && {
    content: '""',
    boxShadow: '0px -1px 4px rgba(194, 80, 255, 0.40)',
    border: '2px #C250FF solid',
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
    zIndex: 999,
  },
}));